/**
 * @description
 * Objeto Mail
 */

 export class Mail {
    public emisor:string;
    //public receptor:string;
    public asunto:string;
    public cuerpo:string;
    //public archivo: FormData = new FormData();
  
    constructor() {}
}